import CryptoJS from 'crypto-js'

//   originally 베이직 학생앱 → 프리미엄 학생앱 라우팅용으로 도입됐었고
//   마이그레이션시 통합student-up의 sessionStorage 토큰 을 통합 student로 보내주어야해서 추가 (handleStudentUpLogic.ts)
const HASH_SALT = 'vmfldnlffls1!'

export type MigrationHashPayload = {
  accessToken?: string
  refreshToken?: string
  studentId?: string
  academyId?: string
  isPersist?: boolean
}

export const encodeMigrationHash = (payload: MigrationHashPayload): string =>
  CryptoJS.AES.encrypt(JSON.stringify(payload), HASH_SALT).toString()

// 디코드는 malformed ciphertext 에서 JSON.parse 가 throw — 호출측은 try/catch 또는
// 사전 truthy 검사 (`ciphertext ? decodeMigrationHash(ciphertext) : null`) 로 처리.
export const decodeMigrationHash = (ciphertext: string): MigrationHashPayload => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, HASH_SALT)
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
}
